import { render } from "./ContentMain.vue?vue&type=template&id=621a5427&scoped=true"
import script from "./ContentMain.vue?vue&type=script&lang=js"
export * from "./ContentMain.vue?vue&type=script&lang=js"

import "./ContentMain.vue?vue&type=style&index=0&id=621a5427&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621a5427"]])

export default __exports__